import { jsxs as d, Fragment as f, jsx as r } from "react/jsx-runtime";
import { useState as p } from "react";
import { UserMenuItemContainer as u, UserMenuAccordionIcon as I, UserMenuAccordionItemContainer as C, UserMenuAccordionSelectedIcon as U } from "./style.js";
import { ConditionalLink as x } from "../ConditionalLink/index.js";
import { Check as M, ChevronUp as k, ChevronDown as A } from "@pelando/fontawesome/icons";
function E({
  label: t,
  icon: s,
  onClick: c,
  accordionOptions: o,
  url: l,
  target: a,
  ...m
}) {
  const [i, h] = p(!1), n = o && o.length > 0;
  return /* @__PURE__ */ d(f, { children: [
    /* @__PURE__ */ r(x, { url: l, target: a, children: /* @__PURE__ */ d(
      u,
      {
        keepDropdownOpen: n,
        onClick: () => {
          n && h(!i), c == null || c();
        },
        ...m,
        children: [
          s,
          t,
          n && /* @__PURE__ */ r(I, { icon: i ? k : A })
        ]
      }
    ) }),
    i && n && o.map((e) => /* @__PURE__ */ d(
      C,
      {
        "aria-selected": e.isSelected,
        onClick: e.onClick,
        children: [
          /* @__PURE__ */ r("span", { children: e.label }),
          e.isSelected && /* @__PURE__ */ r(U, { icon: M })
        ]
      },
      e.label
    ))
  ] });
}
export {
  E as UserMenuItem
};
